import React from 'react'
import { Col, Row } from 'antd'
import moment from 'moment'

import { RequestQuoteAirFlight } from 'src/types'

import { Text } from 'src/components/atoms'
import getNameOfTheAirline from 'src/components/atoms/get-name-of-the-airline'

import { SecondaryText, StrongText } from '../../styles'

interface Props {
  item: RequestQuoteAirFlight
}

function InfoItemHistory({ item }: Props): JSX.Element {
  const company = getNameOfTheAirline(item.company)
  return (
    <Row
      align="middle"
      gutter={24}
      justify="center"
      type="flex"
      style={{
        marginBottom: 24
      }}
    >
      <Col span={8}>
        <Row
          align="middle"
          justify="center"
          type="flex"
          style={{ flexDirection: 'column' }}
        >
          <SecondaryText>
            {moment.unix(item.departure_date).utc().format('DD/MM/YYYY')}
          </SecondaryText>
          <StrongText>
            {moment.unix(item.departure_date).utc().format('HH:mm')}
          </StrongText>
          <SecondaryText>{item.flight_origin}</SecondaryText>
        </Row>
      </Col>
      <Col span={8}>
        <Row
          align="middle"
          justify="center"
          type="flex"
          style={{ flexDirection: 'column' }}
        >
          <span>
            <Text
              suffix=" "
              text="web.services.airs.operated-by"
              type="secondary"
            />
            <Text strong>{company}</Text>
          </span>
        </Row>
      </Col>
      <Col span={8}>
        <Row
          align="middle"
          justify="center"
          type="flex"
          style={{ flexDirection: 'column' }}
        >
          <SecondaryText>
            {moment.unix(item.arrival_date).utc().format('DD/MM/YYYY')}
          </SecondaryText>
          <StrongText>
            {moment.unix(item.arrival_date).utc().format('HH:mm')}
          </StrongText>
          <SecondaryText>{item.flight_destiny}</SecondaryText>
        </Row>
      </Col>
    </Row>
  )
}

export default InfoItemHistory
